// extracted by mini-css-extract-plugin
export default {"pinkButton":"PinkButton_pinkButton__+JeL5"};